<template>
  <div class="destinations-container-phone">
    <div class="row">
      <div class="">
        <div class="d-flex flex-column justify-content-between align-items-start w-100" style="gap: 15px;">
          <span class="merriweather-bold-p16 text-center w-100">Nos destinations</span>

          <div class="px-4 py-3">
            <div class="d-flex flex-column" style="gap: 30px;">
              <div
                v-for="(destination) in sortedDestinations"
                :key="destination.name"
                class="pb-3 border-bottom-desti"
              >
                <div class="raleway-bold-p16 text-left pb-3 no-translate" @click="goToDestination(`/destination/${destination.slug}`)">{{ destination.name }}</div>
                <div class="destination-section pr-4">
                  <div
                    class="raleway-medi-p15 text-left item-link"
                    v-for="region in destination.regions.filter(d => d.get_lodgings && d.get_lodgings.length > 0)"
                    :key="region.name"
                    @click="goToDestination(region.url || `/destination/${region.slug}`)"
                  >
                    {{ region.name }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="align-items-center all-destinations d-flex justify-content-center pt-4 w-100">
            <a href="/destination" class="hortense-btn-primary raleway-bold-p" target="_blank">TOUTES NOS DESTINATIONS</a>
          </div>
          <div class="d-flex justify-content-center align-items-center w-100 pb-5">
            <img
              src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Nos+destinations.jpg"
              alt="Destinations"
              class="img-destination pt-2"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: 'DestinationsList',
  props: {
    destinations: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      additionalRegions: [
        {
          name: 'Paris et ses environs',
          url: 'https://www.hortense.green/hebergements-moins-2h-paris',
          slug: 'paris-et-ses-environs',
          get_lodgings: [1]
        },
        {
          name: 'Lyon et ses environs',
          url: 'https://www.hortense.green/hebergements-moins-2h-lyon',
          slug: 'lyon-et-ses-environs',
          get_lodgings: [1]
        },
        {
          name: 'Bordeaux et ses environs',
          url: 'https://www.hortense.green/hebergements-moins-2h-bordeaux',
          slug: 'bordeaux-et-ses-environs',
          get_lodgings: [1]
        }
      ],
      additionalDestinations: [
        {
          name: 'Europe',
          slug: 'europe',
          regions: [
            {
              name: 'Italie',
              slug: 'italie',
              get_lodgings: [1]
            }
          ]
        }
      ]
    };
  },
  methods: {
    goToDestination(url) {
      window.open(url, '_blank');
    }
  },
  computed: {
    sortedDestinations() {
      const order = ['FRANCE', 'OCÉAN INDIEN', 'CARAÏBES', 'AFRIQUE', 'EUROPE'];
      const destinations = this.destinations.map(d => ({
        regions: [...(d.regions || [])],
        ...d
      }));

      this.additionalDestinations.forEach((extraDestination) => {
        const exists = destinations.some(
          d => d.name && d.name.toUpperCase() === extraDestination.name.toUpperCase()
        );

        if (!exists) {
          destinations.push(extraDestination);
        }
      });
      
      // Find FRANCE destination and add additional regions (only if not already added)
      const franceDestination = destinations.find(d => d.name.toUpperCase() === 'FRANCE');
      if (franceDestination) {
        const existingNames = new Set(franceDestination.regions.map(r => r.name));
        const newRegions = this.additionalRegions.filter(r => !existingNames.has(r.name));
        franceDestination.regions = [ ...newRegions, ...franceDestination.regions];
      }

      const europeDestination = destinations.find(d => d.name.toUpperCase() === 'EUROPE');
      if (europeDestination) {
        const existingNames = new Set((europeDestination.regions || []).map(r => r.name));
        const italyRegion = {
          name: 'Italie',
          slug: 'italie',
          get_lodgings: [1]
        };

        europeDestination.regions = existingNames.has(italyRegion.name)
          ? europeDestination.regions
          : [italyRegion, ...(europeDestination.regions || [])];
      }
      
      return destinations.sort((a, b) => {
        const indexA = order.indexOf(a.name.toUpperCase());
        const indexB = order.indexOf(b.name.toUpperCase());

        return (indexA === -1 ? Infinity : indexA) - (indexB === -1 ? Infinity : indexB);
      });
    }
  }
}
</script>

<style scoped>
.destinations-container-phone {
  height: 418px;
  top: 160px;

  text-transform: capitalize !important;

  .img-destination {
    width: 360px;
    height: 195px;
    object-fit: cover;
  }

  .destination-section {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 24px;

    .item-link {
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
  }

  .border-bottom-desti {
    border-bottom: 1px solid #BFBFBF;
    align-self: stretch;
  }

  .border-bottom-desti:not(:last-of-type) {
    border-bottom: 1px solid #BFBFBF;
  }

  .border-bottom-desti:last-of-type {
    border-bottom: none;
  }

  .border-bottom-desti::after {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    height: calc(100% - 20px);
    border-bottom: 1px solid #BFBFBF;
  }
}
</style>